export default {
  logs: {
    filter: "Filter",
    searchPlaceholder: "Search by module, action or comment...",
    table: {
      date: "Date",
      module: "Module",
      action: "Action",
      comment: "Comment",
      noResults: "No logs found",
    },
    filterPopup: {
      title: "Filter Logs",
      module: "Module",
      modulePlaceholder: "Module name",
      action: "Action",
      actionPlaceholder: "Action type",
      comment: "Comment",
      commentPlaceholder: "Comment content",
      dateMin: "Minimum date",
      dateMax: "Maximum date",
    }
  }
};
